export const REGISTER = "register";
export const REGISTER_SUCCESS = "register_success";
export const RESTORE_REGISTER_INITIAL = "restore_register_initial";

export const VERIFY_USER_EMAIL = "verify_user_email";
export const VERIFY_USER_EMAIL_SUCCESS = "verify_user_email_success";
export const RESTORE_VERIFY_USER_EMAIL_INITIAL = "restore_verify_user_email_initial";

export const RESEND_MAIL = "resend_mail";
export const RESEND_MAIL_SUCCESS = "resend_mail_success";
export const RESTORE_RESEND_MAIL_INITIAL = "restore_resend_mail_initial";

export const LOGIN = "login";
export const LOGIN_SUCCESS = "login_success";
export const RESTORE_LOGIN_INITIAL = "restore_login_initial";

export const FORGOT_PASSWORD = "forgot_password";
export const FORGOT_PASSWORD_SUCCESS = "forgot_password_success";
export const RESTORE_FORGOT_PASSWORD_INITIAL = "restore_forgot_password_initial";

export const RESET_PASSWORD = "reset_password";
export const RESET_PASSWORD_SUCCESS = "reset_password_success";
export const RESTORE_RESET_PASSWORD_INITIAL = "restore_reset_password_initial";

export const FETCH_ALL_COUNTRIES = "get_all_countries";
export const FETCH_ALL_COUNTRIES_SUCCESS = "get_all_countries_success";

export const GOOGLE_LOGIN = "google_login";
export const GOOGLE_LOGIN_SUCCESS = "google_login_success";
export const RESTORE_GOOGLE_LOGIN_INITIAL = "restore_google_login_initial";

export const FETCH_ALL_TRENDING_BOOKS = "fetch_all_trending_books";
export const FETCH_ALL_TRENDING_BOOKS_SUCCESS = "fetch_all_trending_books_success";

export const FETCH_ALL_TRENDING_BOOKS_UNAUTH = "fetch_all_trending_books_unauth";
export const FETCH_ALL_TRENDING_BOOKS_UNAUTH_SUCCESS = "fetch_all_trending_books_unauth_success";

export const FETCH_MY_BOOKS = "fetch_my_books";
export const FETCH_MY_BOOKS_SUCCESS = "fetch_my_books_success";

export const FETCH_ALL_BOOKS = "fetch_all_books";
export const FETCH_ALL_BOOKS_SUCCESS = "fetch_all_books_success";

export const ADD_GOALS = "add_goals";
export const ADD_GOALS_SUCCESS = "add_goals_success";
export const RESTORE_ADD_GOALS_INITIAL = "restore_add_goals_initial";

export const FETCH_ALL_GOALS = "fetch_all_goals";
export const FETCH_ALL_GOALS_SUCCESS = "fetch_all_goals_success";

export const DELETE_GOAL = "delete_goal";
export const DELETE_GOAL_SUCCESS = "delete_goal_success";
export const RESTORE_DELETE_GOAL_INITIAL = "restore_delete_goal_initial";

export const SEND_WISHLIST = "send_wishlist";
export const SEND_WISHLIST_SUCCESS = "send_wishlist_success";
export const RESTORE_SEND_WISHLIST_INITIAL = "restore_send_wishlist_initial";

export const FETCH_MY_FAVORITES = "fetch_my_favorites";
export const FETCH_MY_FAVORITES_SUCCESS = "fetch_my_favorites_success";

export const FETCH_POPULAR_AUTHORS = "fetch_popular_author";
export const FETCH_POPULAR_AUTHORS_SUCCESS = "fetch_popular_author_success";

export const FETCH_NEW_RELEASES = "fetch_new_releases";
export const FETCH_NEW_RELEASES_SUCCESS = "fetch_new_releases_success";

export const FETCH_CLASSIC_BOOKS = "fetch_classic_book";
export const FETCH_CLASSIC_BOOKS_SUCCESS = "fetch_classic_book_success";

export const FETCH_KIDDIES_BOOKS = "fetch_kiddies_book";
export const FETCH_KIDDIES_BOOKS_SUCCESS = "fetch_kiddies_book_success";

export const FETCH_ALL_GENRE = "fetch_all_genre";
export const FETCH_ALL_GENRE_SUCCESS = "fetch_all_genre_success";

export const FETCH_BOOKS_BY_GENRE = "fetch_books_by_genre";
export const FETCH_BOOKS_BY_GENRE_SUCCESS = "fetch_books_by_genre_success";

export const FETCH_BOOKS_BY_AUTHOR = "fetch_books_by_author";
export const FETCH_BOOKS_BY_AUTHOR_SUCCESS = "fetch_books_by_author_success";

export const FETCH_ALL_BOOK_NAMES = "fetch_all_book_names";
export const FETCH_ALL_BOOK_NAMES_SUCCESS = "fetch_all_book_names_success";

export const FETCH_ALL_AUTHORS = "fetch_all_author";
export const FETCH_ALL_AUTHORS_SUCCESS = "fetch_all_author_success";

export const FETCH_BOOKS_DETAILS = "fetch_book_details";
export const FETCH_BOOKS_DETAILS_SUCCESS = "fetch_book_details_success";
export const RESTORE_FETCH_BOOKS_DETAILS = "restore_fetch_books_details";

export const ADD_BOOK_TO_FAVOURITE = "add_book_to_favourite";
export const ADD_BOOK_TO_FAVOURITE_SUCCESS = "add_book_to_favourite_success";
export const RESTORE_FAVOURITE_INITIAL = "restore_favourite_initial";

export const REMOVE_BOOK_FROM_FAVOURITE = "remove_book_from_favourite";
export const REMOVE_BOOK_FROM_FAVOURITE_SUCCESS = "remove_book_from_favourite_success";
export const RESTORE_UNFAVOURITE_INITIAL = "restore_unfavourite_initial";

export const ADD_REVIEW = "add_review";
export const ADD_REVIEW_SUCCESS = "add_review_success";
export const RESTORE_ADD_REVIEW_INITIAL = "restore_add_review_initial";

export const FETCH_AUTHORS_BY_ID = "fetch_author_by_id";
export const FETCH_AUTHORS_BY_ID_SUCCESS = "fetch_author_by_id_success";

export const UPDATE_PROFILE = "update_profile";
export const UPDATE_PROFILE_SUCCESS = "update_profile_success";
export const RESTORE_UPDATE_PROFILE_INITIAL = "restore_update_profile_initial";

//FOR THE READERS COMPONENT ACTION
export const UPDATE_READERS_BOOK = "update_readers_book";
export const UPDATE_CURRENT_PAGE = "update_current_page";
export const CLEAR_BOOK = "clear_book";
export const UPDATE_TOC = "update_toc";
export const CLEAR_TOC = "clear_toc";

export const FETCH_PROFILE = "fetch_profile";
export const FETCH_PROFILE_SUCCESS = "fetch_profile_success";

export const ADD_BANK = "add_bank";
export const ADD_BANK_SUCCESS = "add_bank_success";
export const RESTORE_ADD_BANK_INITIAL = "restore_add_bank_initial";

export const FETCH_ALL_BANKS = "fetch_all_banks";
export const FETCH_ALL_BANKS_SUCCESS = "fetch_all_banks_success";

export const FETCH_WALLET_DETAILS = "fetch_wallet_details";
export const FETCH_WALLET_DETAILS_SUCCESS = "fetch_wallet_details_success";

export const WITHDRAW_FUNDS = "withdraw_funds";
export const WITHDRAW_FUNDS_SUCCESS = "withdraw_funds_success";
export const RESTORE_WITHDRAW_FUNDS_INITIAL = "restore_withdraw_fund_initial";

export const CANCEL_TRIAL = "cancel_trial";
export const CANCEL_TRIAL_SUCCESS = "cancel_trial_success";
export const RESTORE_CANCEL_TRIAL_INITIAL = "restore_cancel_trial_initial";

export const CANCEL_SUBSCRIPTION = "cancel_subscription";
export const CANCEL_SUBSCRIPTION_SUCCESS = "cancel_subscription_success";
export const RESTORE_CANCEL_SUBSCRIPTION_INITIAL = "restore_cancel_subscription_initial";

export const REACTIVATE_TRIAL = "reactivate_trial";
export const REACTIVATE_TRIAL_SUCCESS = "reactivate_trial_success";
export const RESTORE_REACTIVATE_TRIAL_INITIAL = "restore_reactivate_trial_initial";

export const REACTIVATE_SUBSCRIPTION = "reactivate_subscription";
export const REACTIVATE_SUBSCRIPTION_SUCCESS = "reactivate_subscription_success";
export const RESTORE_REACTIVATE_SUBSCRIPTION_INITIAL = "restore_reactivate_subscription_initial";

export const WEB_PURCHASE = "web_purchase";
export const WEB_PURCHASE_SUCCESS = "web_purchase_success";
export const RESTORE_WEB_PURCHASE_INITIAL = "restore_web_purchase_initial";

export const FETCH_SUBSCRIPTION_DETAILS = "fetch_subscription_details";
export const FETCH_SUBSCRIPTION_DETAILS_SUCCESS = "fetch_subscription_details_success";

export const CHANGE_PASSWORD = "change_password";
export const CHANGE_PASSWORD_SUCCESS = "change_password_success";
export const RESTORE_CHANGE_PASSWORD_INITIAL = "restore_change_password_initial";

export const SEARCH_BOOK = "search_book";
export const SEARCH_BOOK_SUCCESS = "search_book_success";
export const RESTORE_SEARCH_BOOK_INITIAL = "restore_search_book_initial";

export const READ_BOOK = "read_book";
export const READ_BOOK_SUCCESS = "read_book_success";

export const SEARCH_BOOK_UNAUTH = "search_book_unauth";
export const SEARCH_BOOK_UNAUTH_SUCCESS = "search_book_unauth_success";
export const RESTORE_SEARCH_BOOK_UNAUTH_INITIAL = "restore_search_book_unauth_initial";

export const REMOVE_FROM_LIBRARY = "remove_from_library";
export const REMOVE_FROM_LIBRARY_SUCCESS = "remove_from_library_success";
export const RESTORE_REMOVE_FROM_LIBRARY_INITIAL = "remove_from_library_initial";

export const DELETE_ACCOUNT = "delete_account";
export const DELETE_ACCOUNT_SUCCESS = "delete_account_success";
export const RESTORE_DELETE_ACCOUNT_INITIAL = "restore_delete_account_initial";

export const FETCH_SONGS = "fetch_songs";
export const FETCH_SONGS_SUCCESS = "fetch_songs_success";

export const UPDATE_READING_TIME = "update_reading_time";
export const UPDATE_READING_TIME_SUCCESS = "update_reading_time_success";
export const RESTORE_UPDATE_READING_TIME_INITIAL = "restore_update_reading_time_initial";

export const HIDE_FACEBOOK_ICON = "hide_facebook_icon";
export const HIDE_FACEBOOK_ICON_SUCCESS = "hide_facebook_icon_success";
export const RESTORE_HIDE_FACEBOOK_ICON_INITIAL = "restore_hide_facebook_icon_initial";

// ==============================writing challenge================

export const FETCH_ARTICLE_TOPICS = "fetch_article_topics";
export const FETCH_ARTICLE_TOPICS_SUCCESS = "fetch_article_topics_success";

export const FETCH_ALL_ARTICLE = "fetch_all_article";
export const FETCH_ALL_ARTICLE_SUCCESS = "fetch_all_article_success";

export const FETCH_ARTICLE_BY_TOPIC = "fetch_article_by_topic";
export const FETCH_ARTICLE_BY_TOPIC_SUCCESS = "fetch_article_by_topic_success";
export const RESTORE_FETCH_ARTICLE_BY_TOPIC = "restore_fetch_article_by_topic";

export const CREATE_ARTICLE = "create_article";
export const CREATE_ARTICLE_SUCCESS = "create_article_success";
export const RESTORE_CREATE_ARTICLE_INITIAL = "restore_create_article_initial";

export const EDIT_ARTICLE = "edit_article";
export const EDIT_ARTICLE_SUCCESS = "edit_article_success";
export const RESTORE_EDIT_ARTICLE_INITIAL = "restore_edit_article_initial";

export const FETCH_ARTICLE_BY_ID = "fetch_article_by_id";
export const FETCH_ARTICLE_BY_ID_SUCCESS = "fetch_article_by_id_success";

export const VOTE_ARTICLE = "vote_article";
export const VOTE_ARTICLE_SUCCESS = "vote_article_success";
export const RESTORE_VOTE_ARTICLE_INITIAL = "restore_vote_article_initial";

export const FETCH_ARTICLE_BY_USER = "fetch_article_by_user";
export const FETCH_ARTICLE_BY_USER_SUCCESS = "fetch_article_by_user_success";

export const SEND_ARTICLE_LINK = "send_article_link";
export const SEND_ARTICLE_LINK_SUCCESS = "send_article_link_success";

export const FETCH_ALL_BLOGS = "fetch_all_blogs";
export const FETCH_ALL_BLOGS_SUCCESS = "fetch_all_blogs_success";

export const FETCH_BLOG_BY_ID = "fetch_blog_by_id";
export const FETCH_BLOG_BY_ID_SUCCESS = "fetch_blog_by_id_success";

export const UPLOAD_PROFILE_IMAGE = "upload_profile_image";
export const UPLOAD_PROFILE_IMAGE_SUCCESS = "upload_profile_image_success";
export const RESTORE_UPLOAD_PROFILE_IMAGE_INITIAL = "restore_upload_profile_image_initial";

export const FETCH_BOOKS_BY_SUGGESTION = "fetch_books_by_suggestion";
export const FETCH_BOOKS_BY_SUGGESTION_SUCCESS = "fetch_books_by_suggestion_success";

export const FETCH_ALL_BANNERS = "fetch_all_banners";
export const FETCH_ALL_BANNERS_SUCCESS = "fetch_all_banners_success";

export const FETCH_LEADERBOARD_SUMMARY = "fetch_leaderboard_summary";
export const FETCH_LEADERBOARD_SUMMARY_SUCCESS = "fetch_leaderboard_summary_success";

export const FETCH_LEADERBOARD_CATEGORY = "fetch_leaderboard_category";
export const FETCH_LEADERBOARD_CATEGORY_SUCCESS = "fetch_leaderboard_category_success";
export const FETCH_LEADERBOARD_CATEGORY_FAILURE = "fetch_leaderboard_category_failure";

export const FETCH_ANALYTICS_OVERVIEW_SUMMARY = "fetch_analytics_overview_summary";
export const FETCH_ANALYTICS_OVERVIEW_SUMMARY_SUCCESS = "fetch_analytics_overview_summary_success";
export const FETCH_ANALYTICS_OVERVIEW_SUMMARY_FAILURE = "fetch_analytics_overview_summary_failure";

export const FETCH_ANALYTICS_READING_HISTORY = "fetch_analytics_reading_history";
export const FETCH_ANALYTICS_READING_HISTORY_SUCCESS = "fetch_analytics_reading_history_success";
export const FETCH_ANALYTICS_READING_HISTORY_FAILURE = "fetch_analytics_reading_history_failure";

export const FETCH_ANALYTICS_READING_STREAK = "fetch_analytics_reading_streak";
export const FETCH_ANALYTICS_READING_STREAK_SUCCESS = "fetch_analytics_reading_streak_success";
export const FETCH_ANALYTICS_READING_STREAK_FAILURE = "fetch_analytics_reading_streak_failure";

export const FETCH_ANALYTICS_ACHIEVEMENTS = "fetch_analytics_achievements";
export const FETCH_ANALYTICS_ACHIEVEMENTS_SUCCESS = "fetch_analytics_achievements_success";
export const FETCH_ANALYTICS_ACHIEVEMENTS_FAILURE = "fetch_analytics_achievements_failure";

export const FETCH_ANALYTICS_INSIGHTS = "fetch_analytics_insights";
export const FETCH_ANALYTICS_INSIGHTS_SUCCESS = "fetch_analytics_insights_success";
export const FETCH_ANALYTICS_INSIGHTS_FAILURE = "fetch_analytics_insights_failure";

export const FETCH_READING_PREFERENCES = "fetch_reading_preferences";
export const FETCH_READING_PREFERENCES_SUCCESS = "fetch_reading_preferences_success";
export const FETCH_READING_PREFERENCES_FAILURE = "fetch_reading_preferences_failure";

export const UPDATE_READING_PREFERENCES = "update_reading_preferences";
export const UPDATE_READING_PREFERENCES_SUCCESS = "update_reading_preferences_success";
export const UPDATE_READING_PREFERENCES_FAILURE = "update_reading_preferences_failure";
